/** @jsxImportSource @emotion/react */
import { withMyTheme } from "../../theme/theme"
import { css, IconButton, InputAdornment } from "@mui/material"
import { CalendarIcon, DatePicker } from "@mui/x-date-pickers"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { useState } from "react"

interface MyDatePickerProps {
    label: string
    value: Date | null
    onChange: (date: Date | null) => void
    minDate?: Date
}

const DatePickerStyle = withMyTheme((theme) => css`
    width: 100%;
    
    .MuiOutlinedInput-root {
        border-radius: 12px;
        background-color: white;
        
        &:hover .MuiOutlinedInput-notchedOutline {
            border-color: ${theme.palette.primary.main};
        }
        
        &.Mui-focused .MuiOutlinedInput-notchedOutline {
            border-color: ${theme.palette.primary.main};
            border-width: 2px;
        }
    }
    
    .MuiInputLabel-root {
        color: ${theme.palette.text.primary};
        font-size: 1rem;
        
        &.Mui-focused {
            color: ${theme.palette.primary.main};
        }
        
        @media (min-width: 768px) {
            font-size: 1.4rem;
        }
    }
    
    .MuiInputBase-input {
        font-size: 1rem;
        
        @media (min-width: 768px) {
            font-size: 1.4rem;
            padding: 20px 24px;
        }
    }

    .MuiInputLabel-root {
        background: white;
        padding: 0 6px;     
    }
`)

const DatePickerIconStyle = withMyTheme((theme) => css`
    color: ${theme.palette.primary.main};
`)

export const MyDatePicker = ({ label, value, onChange, minDate }: MyDatePickerProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                label={label}
                value={value}
                onChange={onChange}
                minDate={minDate}
                format="dd/MM/yyyy"
                css={DatePickerStyle}
                open={isOpen}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                slotProps={{
                    textField: {
                    
                        // We make the text field clickable to open the picker
                        onClick: () => setIsOpen(true),
                        InputProps: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setIsOpen(true)} css={DatePickerIconStyle}>
                                        <CalendarIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }
                    }
                }}
            />
        </LocalizationProvider>
    )
}